import TechNavbar from "../components/TechNavbar";
import Footer from "../components/Footer";
import FadeInSection from "../components/FadeInSection";
import OurTeamsHeroSection from "../components/OurTeams/OurTeamsHeroSection";
import OurTeamSection from "../components/OurTeams/TeamsSection";
import CTASection from "../components/OurTeams/CTASection";
import CultureSection from "../components/OurTeams/CultureSection";

const OurTeamPage = () => {
  return (
    <div className="min-h-screen flex flex-col font-sans text-slate-900">
      <TechNavbar />
      <main className="flex-grow">
        <FadeInSection>
          <OurTeamsHeroSection />
        </FadeInSection>

        <FadeInSection>
          <OurTeamSection />
        </FadeInSection>

        <FadeInSection>
          <CultureSection />
        </FadeInSection>

        <FadeInSection>
          <CTASection />
        </FadeInSection>
      </main>
      <Footer />
    </div>
  );
};

export default OurTeamPage;
